import { Component, Output, EventEmitter } from '@angular/core';
import { NavigationService } from '../../services/navigation.service';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { SecurityService } from 'src/app/services/security.service';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'sidebar',
    templateUrl: './sidebar.component.html',
    standalone: false
})
export class SidebarComponent {
    @Output() triggerSliderInit = new EventEmitter<any>();

    constructor(private navigationService: NavigationService, private securityService: SecurityService,
        private appInsightsService: ApplicationInsights
        ) {
    }

    public toggleTab(componentLookupKey: string): void {
        this.navigationService.toggleComponentByName(componentLookupKey);

        if (componentLookupKey === 'PeerSelectionComponent') {
            this.triggerSliderInit.emit();
        }
    }

    public isPageOpen(componentName: string): boolean {
        return this.navigationService.isComponentShowing(componentName);
    }

    public signOut() {
        this.appInsightsService.clearAuthenticatedUserContext();
        this.securityService.logout();
    }
}
